module.exports = __webpack_public_path__ + "04859d367e853fb746f75504d4c4ea50.jpg";